export default __webpack_public_path__ + "static/media/Vector.bb296869.svg";